<script setup>
import { computed, watch, nextTick } from 'vue'
import { useForm } from '@inertiajs/vue3'
import Modal from '@pages/Shared/Modal.vue'
import Spinner from '@pages/Shared/ui/Spinner.vue'
import Input from '@pages/Shared/form/Input.vue'
import Select from '@pages/Shared/form/Select.vue'

const props = defineProps({
    modelValue: Boolean,
    title:      String,
    status:     String,
    classRoom:  { type: Object, default: null },
    sections:   { type: Array,  default: () => [] },
})

const emit = defineEmits(['update:modelValue', 'submitted'])

const form = useForm({
    _method: null,
    id:      null,
    name:    '',
    section: null,
})

const isViewMode = computed(() => props.status === 'view')

watch(() => props.modelValue, async (open) => {
    if (!open) return
    await nextTick()

    if (props.status === 'create') {
        form.reset()
        form.clearErrors()
        return
    }

    if (!props.classRoom) return

    form.clearErrors()
    form.id      = props.classRoom.id           ?? null
    form.name    = props.classRoom.name         ?? ''
    form.section = props.classRoom.section?.id  ?? null
}, { immediate: true })

const handleSubmit    = () => emit('submitted', form)

const handleModalClose = () => {
    form.clearErrors()
    form.reset()
    emit('update:modelValue', false)
}
</script>

<template>
    <Modal
        :model-value="modelValue"
        :title="title"
        @update:modelValue="emit('update:modelValue', $event)"
        @close="handleModalClose"
    >
        <form class="p-4 md:p-5" @submit.prevent="handleSubmit">

            <Input v-model="form.name" type="text" label="Name" placeholder="Class Name"
                :disabled="isViewMode" :error="form.errors.name" class="mb-4" />

            <Select v-model="form.section" label="Section" :options="sections"
                placeholder="Select section" :disabled="isViewMode"
                :error="form.errors.section" class="mb-4" />

            <button
                v-if="!isViewMode"
                type="submit"
                class="w-full px-6 py-3 rounded-lg text-white text-sm font-semibold
                       transition flex justify-center items-center gap-2"
                :class="status === 'edit'
                    ? 'bg-green-600 hover:bg-green-700'
                    : 'bg-primary-700 hover:bg-primary-800'"
                :disabled="form.processing"
            >
                <Spinner v-if="form.processing" :size="14" />
                {{ status === 'edit' ? 'Update Class' : 'Add Class' }}
            </button>

        </form>
    </Modal>
</template>